<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div class="m-portlet m-b-10" :style="{'height':(160)+'px'}">
            <div class="m-portlet__body">
                <el-form label-width="100px" style="width: 1200px">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="筛选学期">
                                <el-select v-model="semester" placeholder="学期"
                                           @change="changeSemester(semester)">
                                    <el-option
                                            v-for="item in semesters"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="筛选学校">
                                <el-select v-model="school" clearable placeholder="学校" filterable remote
                                           :remote-method="handleSearchSchool" @change="changeSchool(school)">
                                    <el-option
                                            v-for="item in schools"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="筛选年级">
                                <el-select v-model="grade" clearable placeholder="年级"
                                           @change="changeGrade(grade)">
                                    <el-option
                                            v-for="item in grades"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="筛选班主任">
                                <el-select v-model="headTeacher" clearable placeholder="班主任" filterable remote
                                           :remote-method="handleSearchHeadTeacher"
                                           @change="changeHeadTeacher(headTeacher)">
                                    <el-option
                                            v-for="item in headTeachers"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="筛选老师">
                                <el-select v-model="teacher" clearable placeholder="老师" filterable remote
                                           :remote-method="handleSearchTeacher"
                                           @change="changeTeacher()">
                                    <el-option
                                            v-for="item in teachers"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="筛选学生名字">
                                <el-select v-model="student" clearable placeholder="学生名字" filterable remote
                                           :remote-method="handleSearchStudent"
                                           @change="changeStudents(student)">
                                    <el-option
                                            v-for="item in haveStudents"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet" :style="{'height':(clientHeight-270)+'px'}">
            <div class="m-portlet__body" :style="{'height':clientHeight-300+'px'}" v-loading="loading">
                <el-table
                        :data="orderStudents"
                        style="width: 100%"
                        size="middle"
                        :height="clientHeight-360"
                >
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column label="学校">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.school.name}}</span>
                            <span v-else>学校未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年级">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.grade.name}}</span>
                            <span v-else>年级未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone" label="学生联系方式"></el-table-column>
                    <el-table-column label="余课情况" width="400">
                        <template slot-scope="scope">
                            <el-row>
                                <p v-for="(studentCrunk,index) in scope.row.studentCrunks" :key="index">
                                    <el-col :span="12"><div style="width:220px;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;" :title="studentCrunk.name">{{studentCrunk.name}}</div></el-col>
                                    <el-col :span="6"><div  style="width: 100px"> 余{{studentCrunk.studentClassNumber}}节课</div></el-col>
                                    <el-col :span="6"><div  style="width: 100px">老师：{{studentCrunk.teacherName}}</div></el-col>
                                </p>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="班主任">
                        <template slot-scope="scope">
                            <span v-for="(headTeacher,index) in scope.row.headTeachers" :key="index"> {{headTeacher.name}} </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       @click="handleStudentInformation(scope.row.id,scope.row.name)">查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Index",
        data() {
            return {
                path: "/crunkStudent/list",
                semester: '',
                semesters: [],
                headTeachers: [],
                teachers: [],
                schools: [],
                grades: [],
                haveStudents: [],
                student: '',
                grade: '',
                school: '',
                headTeacher: '',
                teacher: '',
                confirmStudent: '',
                nowSemester: [],
                headTeacher_student: '',
                notHeadTeacher_student: '',
                haveClass_student: '',
                noHeadTeacher_student: '',
                confirm_student: '',
                haveHeadTeacher_student: '',
                activeNames: ['1'],
                loading: true,
                students: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                check_1: '',
                confirmStudents: [{
                    value: '1',
                    label: '已通知的学生'
                }, {
                    value: '0',
                    label: '未通知的学生'
                }],
                text: ''
            }
        },
        props: {},
        components: {},
        destroyed() {
            this.$Echo.leave('studentList');
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            // this.powers = JSON.parse(localStorage.powers);
            // this.nowSemester = JSON.parse(localStorage.nowSemester);
            this.handleIndexStudent();
            this.handleCreate();
            this.handleSearchSchool("");
            this.handleSearchHeadTeacher("");
            this.handleSearchTeacher("");
            this.handleSearchStudent("");

        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            orderStudents: function () {
                return this._.values(this.students);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'searchSchool',
                    'schoolKeyName': query,
                });
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'searchHeadTeacher',
                    'headTeacherKeyName': query,
                });
            },
            handleSearchTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'searchTeacher',
                    'teacherKeyName': query,
                });
            },
            handleSearchStudent(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'searchStudent',
                    'studentKeyName': query,
                });
            },
            changeStudents() {
                this.loading = true;
                this.handleIndexStudent();
            },
            changeSemester(semester) {
                this.semester = semester;
                this.loading = true;
                this.handleIndexStudent();
            },
            changeHeadTeacher() {
                this.loading = true;
                this.handleIndexStudent();
            },
            changeTeacher() {
                this.loading = true;
                this.handleIndexStudent();
            },
            changeSchool() {
                this.loading = true;
                this.handleIndexStudent();
            },
            changeGrade() {
                this.loading = true;
                this.handleIndexStudent();
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'init', {});
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.semesters = data.semesters;
                        this.grades = data.grades;
                        this.semester = 3;
                        // this.semester=this.nowSemester.id;
                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'searchTeacher':
                        this.teachers = data.searchData;
                        break;
                    case 'searchStudent':
                        this.haveStudents = data.searchData;
                        break;
                    case 'list':
                        this.students = data.students;
                        this.total = data.total;
                        this.loading = false;
                        break;
                }
            },
            handleIndexStudent() {
                const currentPage = this.currentPage;
                const currentPageSize = this.currentPageSize;
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'isHeadTeacherStudent': this.isHeadTeacherStudent,
                    'hasHeadTeacherStudent': this.hasHeadTeacherStudent,
                    'confirm_student': this.confirm_student,
                    'headTeacher': this.headTeacher,
                    'teacher': this.teacher,
                    'school': this.school,
                    'grade': this.grade,
                    'confirmStudent': this.confirmStudent,
                    'courseConfirmStudent': this.courseConfirmStudent,
                    'semester': this.semester,
                    'student': this.student,
                    'nowSemester': 3,
                    // 'nowSemester': this.nowSemester.id,
                });
            },
            handleStudentInformation(student_id, title) {
                // this.$Win.openModal('/student/info/' + student_id, 1400, 1000, title);

                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>
